import React, { Component } from "react";
import UploadFolderIcon from "../../../assets/upload-folder-icon.svg";
import Folder from "./Folder";
import { Row, Upload, Col, Button, Dropdown, Menu } from "antd";
import {
  updateFilesList,
  updateMetadata,
  updateRootFolder
} from "../../../actions/UploadFolderAction";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  createNestedStructure,
  mapFilesListV2,
  removeDuplicatesByProperty
} from "../UploadFolderUtils";
import UploadIcon from "../../../assets/icons/upload-icon.svg";
import UploadPopup from "../../upload-folder-dragzone/upload-popup/UploadPopup";

const Dragger = Upload.Dragger;

class UploadFolderStep1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: {
        visible: false,
        x: 0,
        y: 73,
        blocked: true
      }
    };
  }

  handleUpload = fileList => {
    const fileListMapped = mapFilesListV2(fileList);
    const cleaned = removeDuplicatesByProperty(fileListMapped, "path");
    this.props.updateFilesList(cleaned);
    this.setState({
      popup: {
        visible: false
      }
    });
  };

  componentDidUpdate(prevProps) {
    const { fileList: fileListOld } = prevProps;
    const { fileList: newFileList, user } = this.props;
    if (fileListOld !== newFileList) {
      this.props.updateRootFolder(createNestedStructure(newFileList, user._id));
    }
  }

  render() {
    const { fileList, rootFolder, intl, currentStep, newColor } = this.props;
    const { popup } = this.state;
    return (
      <Row
        style={{
          height: 450
        }}
        type="flex"
        span={24}
      >
        <Col span={15}>
          <div
            style={{
              height: 450,
              paddingLeft: "5%",
              paddingRight: "5%",
              paddingTop: "3%",
              overflowY: "auto"
            }}
          >
            <div>
              {rootFolder.map((folder, index) => (
                <Folder
                  key={folder.path}
                  name={folder.name}
                  files={folder.files}
                  path={folder.path}
                  size={folder.size}
                  folderOrFile={folder}
                  readOnly={folder.readOnly}
                  onDelete={path => {
                    const newList = fileList.filter(e => e.path !== path);
                    this.props.updateFilesList(newList);
                  }}
                  onDeleteFolder={newFolderName => {
                    const newList = fileList.filter(
                      e => !e.path.includes(`${newFolderName}/`)
                    );
                    this.props.updateFilesList(newList);
                  }}
                  onChangeReadOnly={path => {
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        return {
                          ...e,
                          readOnly: !e.readOnly
                        };
                      }
                      return e;
                    });
                    this.props.updateFilesList(newList);
                  }}
                  onChangeReadOnlySelectInput={path => {
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        return {
                          ...e,
                          readOnly: false
                        };
                      }
                      return e;
                    });
                    this.props.updateFilesList(newList);
                  }}
                  onChangeName={(path, newName) => {
                    if (path === newName) return;
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        e.name = newName;
                      }
                      return e;
                    });
                    // this.props.updateRootFolder(newList);
                    this.props.updateFilesList(newList);
                  }}
                  progressVisible={false}
                  fromStep={currentStep}
                />
              ))}
            </div>
          </div>
        </Col>
        <Col span={9} className="u-f-m-upload-section">
          <Dragger
            name="dragger"
            showUploadList={false}
            multiple
            beforeUpload={() => false}
            fileList={fileList}
            onChange={info => this.handleUpload(info.fileList)}
            style={{
              width: "100%",
              height: 450,
              backgroundColor: newColor,
              borderColor: newColor,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: "2%",
              paddingRight: "2%"
            }}
          >
            <div
              className="upload-container"
              style={{
                flexWrap: "wrap",
                gap: "10px 0",
                height: "100%",
                alignContent: "center",
                textAlign: "center"
              }}
            >
              <div style={{ width: "100%" }}>
                <img src={UploadFolderIcon} alt={"upload folder icon"} />
                <p
                  style={{
                    fontFamily: "Roboto",
                    color: "white",
                    fontWeight: 500,
                    marginTop: 30,
                    textAlign: "center"
                  }}
                >
                  {intl.formatMessage({
                    id: "upload-folder-s1-upload-message"
                  })}
                </p>
              </div>
              <div style={{ width: "100%" }}>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="1"
                        onClick={param => param.domEvent.stopPropagation()}
                      >
                        <Upload
                          name="dragger_files"
                          multiple
                          showUploadList={false}
                          fileList={fileList}
                          beforeUpload={() => {
                            return false;
                          }}
                          onChange={info => {
                            return this.handleUpload(info.fileList);
                          }}
                        >
                          <div
                            style={{
                              width: 180
                            }}
                          >
                            {intl.formatMessage({
                              id: "upload-folder-dragzone-select-files"
                            })}
                          </div>
                        </Upload>
                      </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={param => param.domEvent.stopPropagation()}
                      >
                        <Upload
                          name="dragger_folders"
                          multiple
                          directory
                          showUploadList={false}
                          fileList={fileList}
                          beforeUpload={() => {
                            return false;
                          }}
                          onChange={info => {
                            return this.handleUpload(info.fileList);
                          }}
                        >
                          <div
                            style={{
                              width: 180
                            }}
                          >
                            {intl.formatMessage({
                              id: "upload-folder-dragzone-select-folders"
                            })}
                          </div>
                        </Upload>
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  style={{
                    zIndex: 10
                  }}
                >
                  <Button
                    type="primary"
                    className="main-button"
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    style={{ backgroundColor: newColor, borderColor: newColor }}
                  >
                    <div className="button-content">
                      <div>
                        {intl.formatMessage({
                          id: "upload-folder-dragzone-select"
                        })}
                      </div>
                      <img src={UploadIcon} alt="upload" />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </Dragger>
          <UploadPopup
            visible={popup.visible}
            x={popup.x}
            y={popup.y}
            onFolderSelected={info => {
              return this.handleUpload(info.fileList);
            }}
            onFileSelected={info => {
              return this.handleUpload(info.fileList);
            }}
            intl={intl}
            onMouseEnter={() => {
              this.setState({
                popup: {
                  ...popup,
                  blocked: false
                }
              });
            }}
            onMouseLeave={() => {
              // if(popup.visible && !popup.blocked){
              //     this.setState({
              //         popup: {
              //             ...popup,
              //             visible: false,
              //             blocked: true
              //         }
              //     })
              // }
            }}
          />
        </Col>
      </Row>
    );
  }
}
const mapStateToProps = state => {
  return {
    fileList: state.uploadFolder.fileList,
    currentStep: state.uploadFolder.currentStep,
    rootFolder: state.uploadFolder.rootFolder,
    user: state.authUser.user,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  updateFilesList,
  updateRootFolder,
  updateMetadata
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderStep1))
);
